import request from "../../untils/request.js"

//挂账类型分页
export const getOnCredit = (params) => {
    return request.get("/outpatient/bebttype/page", {params} )
}

export default{

}